import React from 'react'
import BusinessPage from '../components/BusinessPage'

const TaC = () => {
    return (
        <BusinessPage title={"Terms & Conditions"}>
            <p>Welcome to <a href="https://bentodelivaz.com" rel="noreferrer" target="_new">bentodelivaz.com</a>, the proprietary website/application of Bento Delivaz Limited (&ldquo;Bento Delivaz&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;). By accessing this platform, you (&quot;User&rdquo;, &ldquo;you&rdquo;, &ldquo;your&rdquo;) agree to our terms and conditions as outlined below. Please read these terms carefully before using the platform. By using this platform, you agree to be legally bound by these terms. If you have any questions or require clarification, please contact us at hello@bentodelivaz.com.</p>

<h3>1. General Terms</h3>

<p>1.1. These terms govern the use of our website and mobile application (collectively referred to as the &ldquo;Platform&rdquo;) and define the legally binding terms on which you access, browse, register, or otherwise use the Platform to enjoy our services. These terms apply to all users of the Platform, including guest users.</p>

<p>1.2. By using our Platform in any manner, you confirm that you accept these terms of use and agree to comply with and be bound by them.</p>

<p>1.3. You understand that breach of any of these terms may result in your rights to use the services on the Platform being restricted, suspended, or withdrawn.</p>

<p>1.4. We may amend these terms at any time by updating this page. Please check this page periodically to take notice of any changes we make, as they will be binding on you. For existing users, we will notify you of significant changes.</p>

<p>1.5. If you do not agree to these terms, you must not access this Platform or use the services.</p>

<h3>2. Services</h3>

<p>2.1. This Platform allows users to request one of our delivery personnel to order or pick up food from nearby restaurants (Services).</p>

<p>2.2. The Platform features a variety of restaurants from which you can choose to order your preferred meal and have it delivered to you.</p>

<p>2.3. Bento Delivaz may not be affiliated with or have any partnerships with these restaurants. We are only responsible for ordering or purchasing the food on your behalf and delivering it to you.</p>

<p>2.4. We operate the Platform and provide the tools and technical means to facilitate this process. We do not possess any food offered for sale and are not affiliated with the listed restaurants.</p>

<p>2.5. We have no control over and do not guarantee the existence, quality, or safety of the food advertised. We do not guarantee the accuracy of restaurant offers or their ability to prepare meals as described.</p>

<p>2.6. Unlike our delivery services, we cannot guarantee that meals ordered through this Platform will be of satisfactory quality. Any warranties (whether express or implied) are disclaimed to the fullest extent permitted by law.</p>

<h3>3. Accessing our Platform and Services</h3>

<p>3.1. We do not guarantee that our Platform or any services will always be available, uninterrupted, or fault-free. We will not be liable if the Platform is unavailable at any time or for any period.</p>

<p>3.2. We do not guarantee that our Platform or any content on it will be free from errors or omissions.</p>

<p>3.3. You are responsible for making all arrangements necessary to have access to our Platform and for ensuring that all persons who access the Platform through your user profile are aware of these terms and comply with them.</p>

<h3>4. Membership and Registration</h3>

<p>4.1. Our services are available only to individuals who are 18 years or older and can form legally binding contracts under applicable law. By registering, you represent that you are at least 18 years old and that all registration information you submit is accurate and truthful.</p>

<p>4.2. Users meeting the above criteria must create an account in accordance with clause 4.3.</p>

<p>4.3. To create an account, you must provide your full name, email address, telephone number, and delivery address. A one-time password will be provided upon registration. You are required to confirm your agreement with our terms of use and privacy policy.</p>

<p>4.4. You are solely responsible for keeping your login details confidential and must not disclose or share them with anyone. You are responsible for all activities and orders made using your login information. In the event of theft, loss, or unauthorized use of your password or account, you must contact us immediately at hello@bentodelivaz.com.</p>

<p>4.5. Once you create an account, you can select restaurants, order meals, and request delivery to your registered address.</p>

<p>4.6. If we suspect a security breach or misuse of our Platform, we reserve the right to require you to change your password. Failure to do so may result in the suspension or deletion of your account.</p>

<p>4.7. As a user, you:</p>

<ul>
	<li>Represent and warrant that all account information provided is accurate, up to date, honest, and not misleading;</li>
	<li>Commit to updating your account information as necessary; and</li>
	<li>Accept sole responsibility for any consequences resulting from the inaccuracy of this information or failure to update it.</li>
</ul>

<p>4.8. The information provided to create or update an account constitutes proof of your identity. We reserve the right to verify this information at any time and to request additional documentation for identity verification.</p>

<p>4.9. You can terminate your account at any time, and your details will be deleted from the Platform.</p>

<h3>5. Payment</h3>

<p>5.1. All payments made on our Platform are processed by a third-party payment processor.</p>

<p>5.2. Payments for orders can be made via:</p>

<ul>
	<li>A closed-loop electronic wallet feature on the Platform, which you top up using available payment channels;</li>
	<li>Debit card;</li>
	<li>Bank transfers; or</li>
	<li>Any other payment methods/channels our payment service partners may provide.</li>
</ul>

<p>5.3. The payment processor is responsible for all payment transactions on our Platform.</p>

<p>5.4. The sale prices of meals are displayed in the offers, given in Naira, and include any applicable taxes.</p>

<p>5.5. The delivery fee can be accessed at the checkout page.</p>

<p>5.6. The total price is stated in the offer at checkout and is due for payment when the order is placed.</p>

<p>5.7. By creating an account, you agree to be bound by these payment terms.</p>

<h3>6. Intellectual Property</h3>

<p>6.1. We and our Partners own all intellectual property rights in the Platform and any materials published on it. These rights are protected under applicable copyright laws, and all such rights are reserved. You may only access and use the materials for personal use and may not reproduce, distribute, publicly display, or modify them without our authorization.</p>

<p>6.2. We own or are the licensor of all rights, titles, and interests in and to the Platform, including all rights under patents, copyrights, design rights, trade secrets, and other proprietary rights. Any unauthorized use of these elements is strictly prohibited and may result in legal action.</p>

<p>6.3. If you believe the content on our Platform infringes on your copyright, please contact us, and we will take steps to address the issue.</p>

<p>6.4. You acknowledge that the descriptions of food items on the Platform were provided by users. Bento Delivaz will not be liable for any inaccuracies. If you believe a food item has been misdescribed, please contact us, and we will take steps to correct it.</p>

<h3>7. No Reliance</h3>

<p>The content on our Platform is for general information only and is not intended as advice. Although we make reasonable efforts to update the information, we make no representations or guarantees about its completeness or accuracy, and you acknowledge that any reliance on such information is at your own risk.</p>

<h3>8. Limitation of Liability</h3>

<p>8.1. Nothing in these terms excludes or limits our liability for personal injury arising from our negligence, fraudulent misrepresentation, or any other liability that cannot be excluded or limited by Nigerian law.</p>

<p>8.2. To the extent permitted by law, we exclude all conditions, warranties, representations, or other terms that may otherwise apply to our Platform or any content on it, whether express or implied.</p>

<p>8.3. We assume no responsibility for the content of websites linked to our Platform. Such links should not be interpreted as endorsements by us. We will not be liable for any loss or damage that may arise from your use of them.</p>

<p>8.4. Although we make reasonable efforts to keep our Platform safe from viruses and other harmful programs, we will not be liable for any loss or damage caused by a virus or other harmful material that may infect your computer due to your use of our Platform or your downloading of any content on it, or any website linked to it.</p>

<h3>9. Applicable Law</h3>

<p>These terms of use are governed by the laws of the Federal Republic of Nigeria. By using our Platform, you agree that any dispute arising from these terms or your use of our Platform will be subject to the exclusive jurisdiction of the courts of Nigeria.</p>

<hr />
<p>If you have any queries or issues regarding our terms and conditions, please contact us at hello@bentodelivaz.com. Thank you for using Bento Delivaz!</p>

        </BusinessPage>
    )
}

export default TaC